import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.BulkCreationBanner', {
    uploadButtonText: 'Bulk Upload',
    description: 'Automatically import {templateName} into ApprovalMax in bulk',
});
